import { findActivePillar, type NavItem } from './navConfig'

function stdVertical(base: string): NavItem[] {
  return [
    { label: 'Overview', to: base },
    { label: 'Flow', to: `${base}/flow` },
    { label: 'UNS Explorer', to: `${base}/explorer` },
    { label: 'Knowledge Graph', to: `${base}/knowledge-graph` },
    { label: 'AI Bot', to: `${base}/bot` },
  ]
}

const VERTICAL_TABS: Record<string, NavItem[]> = {
  '/factory': [
    { label: 'Overview', to: '/factory' },
    { label: 'Flow', to: '/factory/flow' },
    { label: 'Advanced Flow', to: '/factory/advancedflow' },
    { label: 'Multi-site', to: '/factory/multisiteflow' },
    { label: 'Live Line', to: '/factory/line' },
    { label: 'UNS Explorer', to: '/factory/explorer' },
    { label: 'Knowledge Graph', to: '/factory/knowledge-graph' },
    { label: 'AI Bot', to: '/factory/bot' },
  ],
  '/automotive': stdVertical('/automotive'),
  '/energy': stdVertical('/energy'),
  '/pharma': stdVertical('/pharma'),
  '/logistics': stdVertical('/logistics'),
  '/oilandgas': stdVertical('/oilandgas'),
  '/connected': [...stdVertical('/connected'), { label: 'Tracing', to: '/connected/tracing' }],
  '/datacenter': [
    { label: 'Overview', to: '/datacenter' },
    { label: 'Flow', to: '/datacenter/flow' },
    { label: 'Multi-site', to: '/datacenter/multisiteflow' },
    { label: 'UNS Explorer', to: '/datacenter/explorer' },
    { label: 'Knowledge Graph', to: '/datacenter/knowledge-graph' },
    { label: 'AI Bot', to: '/datacenter/bot' },
  ],
}

const PILLAR_TABS: Record<string, NavItem[]> = {
  explore: [
    { label: 'HiveMQ', to: '/hivemqintro' },
    { label: 'Vision', to: '/hivemqvision' },
    // Streaming groups the two data-streaming products behind one dropdown.
    {
      label: 'Streaming',
      to: '/hivemqpilars',
      expandTabs: true,
      children: [
        { label: 'Enterprise Broker', to: '/hivemqpilars' },
        { label: 'Edge', to: '/hivemqedge' },
      ],
    },
    { label: 'Data Intelligence', to: '/pulse' },
    { label: 'Agentic AI', to: '/hivemqagentic' },
  ],
  value: [
    { label: 'Overview', to: '/business-value' },
    { label: 'Smart Manufacturing', to: '/business-value/smart-manufacturing' },
    { label: 'Energy', to: '/business-value/energy' },
    { label: 'Data Centers', to: '/business-value/data-centers' },
    { label: 'Logistics', to: '/business-value/logistics' },
  ],
  learn: [
    { label: 'Overview', to: '/education' },
    { label: 'MQTT', to: '/education/mqtt' },
    { label: 'Sparkplug', to: '/education/sparkplug' },
    { label: 'UNS', to: '/education/uns' },
    { label: 'HiveMQ Cluster', to: '/education/hivemq-cluster' },
    { label: 'TLS & mTLS', to: '/education/tls-mtls' },
    // All Data Hub pages are grouped behind a single dropdown menu tab.
    {
      label: 'Data Hub',
      to: '/datahub',
      children: [
        { label: 'Overview', to: '/datahub' },
        { label: 'Anonymize', to: '/dhanonymizeflow' },
        { label: 'First-to-Contact', to: '/dhftocflow' },
        { label: 'Geolocation', to: '/dhgeolocationflow' },
        { label: 'Sparkplug Fanout', to: '/dhsparkplugfanoutflow' },
      ],
    },
  ],
  tools: [
    { label: 'Playground', to: '/playground' },
    { label: 'MQTT Client', to: '/mqtt-client' },
    { label: 'Demo Info', to: '/demoinfo' },
  ],
}

// In-page sub-tabs for the current context. Within-vertical tabs win when the
// path is inside an industry vertical; otherwise the active pillar's sub-routes.
export function getSectionTabs(pathname: string): NavItem[] {
  for (const base of Object.keys(VERTICAL_TABS)) {
    if (pathname === base || pathname.startsWith(`${base}/`)) {
      return VERTICAL_TABS[base]
    }
  }
  const pillar = findActivePillar(pathname)
  if (pillar && PILLAR_TABS[pillar.id]) {
    return PILLAR_TABS[pillar.id]
  }
  return []
}
